// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"140":"1e78b08f","239":"86bc6427","863":"reg-login"}[chunkId] || chunkId) + "." + {"72":"caed75b3240d0a75","140":"0ef1bafbf9a3ab3a","239":"be362ca33e52d076","853":"e75095048cc3995b","863":"5439248aa947226b"}[chunkId] + ".js";
};